var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 7.16666H16.6667M3.33337 7.16666V14.5002C3.33337 15.4336 3.33337 15.9 3.51503 16.2566C3.67482 16.5702 3.9296 16.8254 4.2432 16.9852C4.59938 17.1667 5.06587 17.1667 5.99747 17.1667H14.0026C14.9342 17.1667 15.4 17.1667 15.7562 16.9852C16.0698 16.8254 16.3254 16.5702 16.4852 16.2566C16.6667 15.9004 16.6667 15.4346 16.6667 14.503V7.16666M3.33337 7.16666V6.50015C3.33337 5.56673 3.33337 5.09967 3.51503 4.74315C3.67482 4.42955 3.9296 4.17477 4.2432 4.01498C4.59972 3.83332 5.06678 3.83332 6.0002 3.83332H6.66671M16.6667 7.16666V6.49741C16.6667 5.56582 16.6667 5.09932 16.4852 4.74315C16.3254 4.42955 16.0698 4.17477 15.7562 4.01498C15.3997 3.83332 14.9336 3.83332 14.0002 3.83332H13.3334M6.66671 3.83332H13.3334M6.66671 3.83332V2.16666M13.3334 3.83332V2.16666M12.0834 12.1667H7.91671",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/vector5.cadc0d62c20960478e4ae078b850416f.svg";
export { ForwardRef as ReactComponent };